import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-check.tsx
/**
* icon.24.check
*
* Keywords: checkmark, tick, confirm, validation, approval, complete, success, affirmative
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2LjA4OCA3LjIxN2EuNS41IDAgMCAxIC44MjQuNTY2bC01LjUgOGEuNS41IDAgMCAxLS43ODguMDQ2bC0zLjUtNGEuNS41IDAgMSAxIC43NTItLjY1OGwzLjA3NiAzLjUxNXoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1220
*/
const Icon24Check = memo(function Icon24Check(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M16.088 7.217a.5.5 0 0 1 .824.566l-5.5 8a.5.5 0 0 1-.788.046l-3.5-4a.5.5 0 1 1 .752-.658l3.076 3.515z"
		})
	});
});
//#endregion
export { Icon24Check };

//# sourceMappingURL=icon-24-check.js.map